import { TAuthProvider } from '@onesource/schemas';
import axios from 'axios';

import { queryClient } from '../../query-client';
import { axiosServiceInstance, setTokenToAxios, TLeaderBoardUser, TSetSession } from '../axios';
import {
  clearAuthProvider,
  getActiveAuthProvider,
  REFRESH_TOKEN_STORAGE_KEY,
  SESSION_STORAGE_KEY,
  setActiveAuthProvider,
  USER_STORAGE_KEY,
} from './auth-provider-utils';

export const getSession = (): string | null => {
  return localStorage.getItem(SESSION_STORAGE_KEY);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
};

export interface TSetSessionWithProvider extends TSetSession {
  authProvider?: TAuthProvider;
  refreshToken?: string;
}

export const setSession = (param: TSetSessionWithProvider) => {
  const { token, user, authProvider, refreshToken } = param;
  localStorage.setItem(SESSION_STORAGE_KEY, token);
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));

  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
  }

  // Store auth provider if specified
  if (authProvider) {
    setActiveAuthProvider(authProvider);
  }

  setTokenToAxios(token);
};

export const getUser = (): TLeaderBoardUser | null => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user ? JSON.parse(user) : null;
};

export const isLoggedIn = (): boolean => {
  const session = getSession();
  return !!session;
};

export const getAuthProvider = (): TAuthProvider => {
  return getActiveAuthProvider();
};

export const logout = async () => {
  try {
    const token = getSession();
    if (token) {
      const rawAxios = axios.create({ baseURL: axiosServiceInstance.defaults.baseURL });
      await rawAxios.post(
        '/auth/sign-out',
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    }
  } catch (error) {
    console.error('Failed to sign out:', error);
  }

  clearAuthProvider();

  // Drop all cached query data (profile, etc.) so a different account
  // logging in next doesn't see the previous user's stale cache.
  queryClient.clear();
};
